export default __webpack_public_path__ + "static/media/FrazerLogo_DarkBackground_Transparent_forweb.c74f2920.png";